import React, { useState, useEffect, useRef } from 'react';
import TPosiblesClientes from './TPosiblesClientes';
import {
  Box,
  Container,
  CircularProgress,
  Typography,
  TextField,
  Button,
  Paper,
  InputAdornment,
  Chip,
} from '@mui/material';
import {
  Search as SearchIcon,
  PersonAdd as PersonAddIcon,
  PersonSearch as PersonSearchIcon,
} from '@mui/icons-material';
import { obtenerPosiblesClientes } from '../../../actions/ClientesAction';
import { useStateValue } from '../../../contexto/store';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
const PosiblesClientesPrincipal = (props) => {
  const mounted = useRef(true);
  const [term, setTerm] = useState('');
  const [{ sesionUsuario }] = useStateValue();
  const [DataPc, setDataPc] = useState([]);
  const [datosCargados, setDatosCargados] = useState(false);
  useEffect(() => {
    if (mounted.current) {
      const usuario = sesionUsuario.usuario.id;
      obtenerPosiblesClientes(usuario).then((response) => {
        if (response.status === 200) {
          setDataPc(response.data);
          setDatosCargados(true);
        } else {
          console.log('no cargo nada');
        }
      });
    }
    return function cleanu() {
      mounted.current = false;
    };
  }, [sesionUsuario]);
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      {/* Header moderno con gradiente */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 3,
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: 2,
                background: 'rgba(255,255,255,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backdropFilter: 'blur(10px)',
              }}
            >
              <PersonSearchIcon sx={{ fontSize: 32, color: 'white' }} />
            </Box>
            <Box>
              <Typography variant="h4" sx={{ color: 'white', fontWeight: 600, mb: 0.5 }}>
                Posibles Clientes
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <Chip 
                  label={`${DataPc.length} posibles clientes`}
                  size="small"
                  sx={{ 
                    backgroundColor: 'rgba(255,255,255,0.2)', 
                    color: 'white',
                    fontWeight: 500,
                    backdropFilter: 'blur(10px)',
                  }}
                />
              </Box>
            </Box>
          </Box>
          
          <Button
            variant="contained"
            startIcon={<PersonAddIcon />}
            component={Link}
            to="/posibleClienteNuevo"
            sx={{
              backgroundColor: 'white',
              color: '#0d47a1',
              fontWeight: 600,
              px: 3,
              py: 1.5,
              borderRadius: 2,
              textTransform: 'none',
              fontSize: '1rem',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.9)',
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
              },
              transition: 'all 0.3s ease',
            }}
          >
            Nuevo Posible Cliente
          </Button>
        </Box>
      </Paper>

      {/* Barra de búsqueda moderna */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 3,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Buscar por nombre, apellido, CI o RUC..."
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: 'text.secondary' }} />
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              backgroundColor: 'background.default',
              '&:hover': {
                backgroundColor: 'action.hover',
              },
              '&.Mui-focused': {
                backgroundColor: 'background.paper',
              },
            },
          }}
        />
      </Paper>

      {/* Tabla de posibles clientes */}
      <Paper
        elevation={0}
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        {datosCargados ? (
          <TPosiblesClientes
            rows={DataPc}
            termc={term}
            history={props.history}
          />
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 8,
              gap: 2,
            }}
          >
            <CircularProgress size={48} thickness={4} />
            <Typography variant="h6" color="text.secondary">
              Cargando posibles clientes...
            </Typography>
          </Box>
        )}
      </Paper>
    </Container>
  );
};
export default withRouter(PosiblesClientesPrincipal);
